import { resetPanAndZoom } from '../actions';
import { getSpacesOptions } from 'owa-timestream-options';
import { orchestrator } from 'satcheljs';
import { expandToolbox, collapseToolbox } from 'owa-timestream-toolbox-common';

orchestrator(resetPanAndZoom, ({ initialLoad }) => {
    if (initialLoad) {
        getSpacesOptions().toolboxCollapsed ? collapseToolbox() : expandToolbox();
    }
});
